import { registerPlugin } from '@capacitor/core';

/**
 * Native audio-session bridge (see NowPlayingPlugin.swift). Its only job is to
 * put the AVAudioSession in `.playback` so WKWebView audio survives lock /
 * backgrounding — the lock-screen metadata and controls are handled on the web
 * side via navigator.mediaSession, which WebKit reads from directly.
 *
 * On the web this resolves to a proxy whose methods reject; callers must gate on
 * isNativeApp() — see useNowPlaying, the only intended consumer.
 */
export interface NowPlayingPlugin {
  /** Configure the audio session for background playback. */
  enable(): Promise<void>;
  /** Release the app's claim on the audio session. */
  disable(): Promise<void>;
}

export const NowPlaying = registerPlugin<NowPlayingPlugin>('NowPlaying');
